import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/Main.vue'
import RegForm from '@/views/RegForm.vue'
import Done from '@/views/Done.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: Main
  },
  {
    path: '/form/:patientType?',
    name: 'RegForm',
    component: RegForm,
    props: true
  },
  {
    path: '/done',
    name: 'Done',
    component: Done
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  }
]

const router = new VueRouter({
  //mode: 'history',
  //base: '/portal/', //process.env.BASE_URL,
  routes
})

export default router
